'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Scripts
----------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  var body = document.querySelector('body');
  var menuLink = document.querySelector('.mobile-menu-link');

  /*----------------------------
  Toggle Mobile Menu
  ----------------------------*/

  function toggleMobileMenu() {
    // Class Toggle
    body.classList.toggle('no-scroll');
    body.classList.toggle('mobile-nav-is-open');

    // Text
    if (body.classList.contains('mobile-nav-is-open')) {
      menuLink.innerText = 'Close';
    } else {
      menuLink.innerText = 'Menu';
    }
  }

  /*----------------------------
  Menu Links
  ----------------------------*/

  menuLink.addEventListener('click', function (e) {
    // e.preventDefault();
    toggleMobileMenu();
  });

  /*----------------------------
  Main Header Linklists
  ----------------------------*/
  var mainHeaderLinks = document.querySelectorAll('.main-header__link');

  [].concat((0, _toConsumableArray3.default)(mainHeaderLinks)).forEach(function (link) {
    var linkLists = link.querySelectorAll('.dropdown-menu-linklist');
    var dropdownMenuLinks = link.querySelectorAll('.dropdown-menu-link');

    // On mouse enter activate the menu item so we can show its submenus using css.
    link.addEventListener('mouseenter', function () {
      link.classList.add('active');
    });

    // On mouse leave deactivate the menu item.
    link.addEventListener('mouseleave', function () {
      link.classList.remove('active');

      // Deactivate all links
      [].concat((0, _toConsumableArray3.default)(dropdownMenuLinks)).forEach(function (dropdownMenuLink) {
        dropdownMenuLink.classList.remove('active');
        if (dropdownMenuLink.getAttribute('style')) {
          dropdownMenuLink.style.display = 'none';
        }
      });

      // Hide the menu linklists
      [].concat((0, _toConsumableArray3.default)(linkLists)).forEach(function (list) {
        list.classList.remove('active');
      });
    });
  });

  /*----------------------------
  Dropdown Menu - Links
  ----------------------------*/
  var dropdownMenuLinks = document.querySelectorAll('.dropdown-menu-link');

  // Event listeners for each menu link that should open a panel and show sub links.
  [].concat((0, _toConsumableArray3.default)(dropdownMenuLinks)).forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      var dropdownMenu = link.closest('.dropdown-menu');
      var linkContainers = dropdownMenu.querySelectorAll('.dropdown-menu-linklist');
      var currentLinkContainer = link.closest('.dropdown-menu-linklist');
      var currentLinkContainerLinks = currentLinkContainer.querySelectorAll('li');

      var nextPanel = link.dataset.nextPanel;
      var linkType = link.dataset.type;
      var nextLinkContainer = linkContainers[nextPanel];

      // If there is a next link container then adjust and activate the links.
      if (nextLinkContainer) {
        var nextLinkContainerLinks = nextLinkContainer.querySelectorAll('li');

        if (link.classList.contains('open-next-panel')) {
          // Activate the links in the opened panel that are associated with this link type.
          if (linkType) {
            [].concat((0, _toConsumableArray3.default)(nextLinkContainerLinks)).forEach(function (link) {
              if (link.classList.contains(linkType)) {
                link.style.display = 'block';
              } else {
                link.style.display = 'none';
              }
            });
          }

          // Add the active class to the next link container
          nextLinkContainer.classList.add('active');
        } else {
          nextLinkContainer.classList.remove('active');
        }
      }

      // Remove the active class from other links in this menu.
      [].concat((0, _toConsumableArray3.default)(currentLinkContainerLinks)).forEach(function (link) {
        link.classList.remove('active');
      });

      // Add the active class to this link.
      link.classList.add('active');
    });
  });

  /*----------------------------
  Dropdown Menu - Linklists
  ----------------------------*/
  var dropdownMenuLinkLists = document.querySelectorAll('.dropdown-menu-linklist');

  // Event listeners for linklists. Expand and collapse.
  [].concat((0, _toConsumableArray3.default)(dropdownMenuLinkLists)).forEach(function (linkList) {
    linkList.addEventListener('mouseleave', function (e) {
      // Get the related linklists within this container.
      var container = linkList.closest('.dropdown-menu');
      var containerLinkLists = container.querySelectorAll('.dropdown-menu-linklist');

      // Check if we are navigating to a related linklist.
      var toPanel = e.toElement;
      if (toPanel.classList.contains('dropdown-menu-linklist')) {
        // If the panel we are going to is before the panel we are navigating from then collapse it and future panels.
        var toPanelIndex = Number(toPanel.dataset.panel);
        [].concat((0, _toConsumableArray3.default)(containerLinkLists)).forEach(function (list, index) {
          if (toPanelIndex < index) {
            // Hide the list.
            list.classList.remove('active');
          }
        });
      }
    });
  });

  /*----------------------------
  Mobile Nav Sub Menu
  ----------------------------*/
  var mobileExpandableMenuLinks = document.querySelectorAll('.mobile-nav-menu-link--has-sub-menu');

  [].concat((0, _toConsumableArray3.default)(mobileExpandableMenuLinks)).forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var linkContainer = link.closest('.mobile-nav-menu__group-link');
      linkContainer.classList.toggle('open');
    });
  });

  /*----------------------------
  Mobile Nav Screen Open
  ----------------------------*/
  var mobileScreenLinks = document.querySelectorAll('.mobile-nav-menu__group-link--opens-screen');
  var mobileScreenBackLinks = document.querySelectorAll('.mobile-nav-back__link');

  [].concat((0, _toConsumableArray3.default)(mobileScreenLinks)).forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var screenName = link.dataset.screen;
      var screen = document.querySelector('.mobile-nav-overlay__screen.' + screenName);
      screen.classList.add('open');
    });
  });

  [].concat((0, _toConsumableArray3.default)(mobileScreenBackLinks)).forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var screen = link.closest('.mobile-nav-overlay__screen');
      screen.classList.remove('open');
    });
  });

  /*----------------------------
  Mobile Nav - Direct Link
  ----------------------------*/
  var mobileNavDirectLinks = document.querySelectorAll('.mobile-nav-menu__group-link--direct');

  [].concat((0, _toConsumableArray3.default)(mobileNavDirectLinks)).forEach(function (link) {
    link.addEventListener('click', function () {
      // Check to see if the links path is the same as the current page.
      var currentPagePathname = window.location.pathname;
      var linkPathname = link.querySelector('a').pathname;

      // If the same then we should toggle the menu so it hides.
      if (currentPagePathname === linkPathname) {
        toggleMobileMenu();
      }
    });
  });

  /*----------------------------
  Search Drawer
  ----------------------------*/
  var searchDrawerIcons = document.querySelectorAll('.search-drawer-icon');
  var searchDrawerInput = document.querySelector('.search-drawer .search-form__input');

  [].concat((0, _toConsumableArray3.default)(searchDrawerIcons)).forEach(function (icon) {
    icon.addEventListener('click', function () {
      // Only open the drawer if not on the search template page.
      if (!body.classList.contains('template-search')) {
        body.classList.toggle('search-drawer-is-open');
        if (body.classList.contains('search-drawer-is-open')) {
          searchDrawerInput.focus();
        }
      }
    });
  });

  /*----------------------------
  Search Form
  ----------------------------*/

  var searchFormClearButtons = document.querySelectorAll('.search-form__clear');

  [].concat((0, _toConsumableArray3.default)(searchFormClearButtons)).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var searchFormContainer = btn.closest('.search-form');
      var searchFormInput = searchFormContainer.querySelector('.search-form__input');
      searchFormInput.value = '';
      searchFormInput.focus();
    });
  });
});